import $ from 'jquery';

var DeviceAssign = (function () {
  'use strict';

  var loader = '<div class="ui active inline loader black-loader"></div>';
  var $modal = $('.js__call-center-add-device-modal');

  var init = function () {
    $('.js__call-center-add-device').on('click', function () {
      var url = $(this).data('path');
      $modal
        .modal({
          autofocus: false,
          observeChanges: false,
          keyboardShortcuts: false,
          onShow: function () {
            var $content = $modal.find('.js__modal-content');
            getContent(url, $content);
          },

          onHidden: function () {
            var $content = $modal.find('.js__modal-content');
            clearModal($content);
          },
        })
        .modal('show');
    });
  };

  function getContent(url, content) {
    $.get(url).done(function (res) {
      content.html(res);
      bindButtons($modal);
      initSearch();
    });
  }

  function clearModal(container) {
    container.html(loader);
  }

  function bindButtons(modal) {
    initSearch();
    $('.js__call-center-device-modal-cancel-btn').on('click', function () {
      modal.modal('hide');
    });

    $('.js__call-center-device-modal-submit-btn').on('click', function () {
      var $form = $(this).closest('form');
      submitForm($form, modal.find('.js__modal-content'), modal);
    });
  }

  function initSearch() {
    var $search = $('.js__call-center-device-codentify-search');
    var path = $search.data('path');
    var $submitButton = $('.js__call-center-device-modal-submit-btn');
    $search.search({
      apiSettings: {
        url: path,
        beforeSend: function (settings) {
          settings.data = {
            codentify: $search.find('.prompt').val(),
          };
          $search.closest('form').addClass('loading');
          return settings;
        },
        onAbort: function () {
          $search.closest('form').removeClass('loading');
        },
        onResponse: function (apiResponse) {
          $search.closest('form').removeClass('loading');
          var response = {
            results: [],
          };

          $.each(apiResponse, function (index, item) {
            response.results.push({
              title: item.name,
              description: item.value,
            });
          });

          if (!response.results.length) {
            $submitButton.attr('disabled', true);
          }

          const isCodentifyInResponse = response.results.some(
            foundDevice => foundDevice.description === $search.find('.prompt').val(),
          );

          if (isCodentifyInResponse) {
            $search.find('#device_assign_admin_codentify').val($search.find('.prompt').val());
            $submitButton.attr('disabled', false);
          }

          return response;
        },
      },
      minCharacters: 3,
      onSelect: function (result) {
        $search.find('#device_assign_admin_codentify').val(result.description);
        $submitButton.attr('disabled', false);
      },
    });
  }

  function submitForm(form, container, modal) {
    if (form.find('#device_assign_admin_codentify').val() === '') {
      form.find('#device_assign_admin_codentify').val(form.find('.prompt').val());
    }
    $.ajax({
      url: form.attr('action'),
      method: form.attr('method'),
      data: {
        'device_assign_admin[codentify]': form.find('#device_assign_admin_codentify').val(),
        'device_assign_admin[_token]': form.find('#device_assign_admin__token').val(),
      },
      beforeSend: function () {
        form.addClass('loading');
      },
      success: function (res) {
        if (res.html !== '') {
          $('.swiper-wrapper').prepend(res.html);
          $('.js__device-slider-init')[0].swiper.update();
          modal.modal('hide');
        } else {
          container.html(res);
          bindButtons(modal);
          form.removeClass('loading');
        }
      },
      complete: function () {},
    });
  }

  return {
    init: init,
  };
})();

export default DeviceAssign;
